import { JsonSchemaValidator } from "@common/json-schema-validator";
import { IAMAccountEntity } from "../entity";

export class IAMAccountCredentialsDownloadCmd {
  private static validation = JsonSchemaValidator.compile(
    IAMAccountCredentialsDownloadCmd.validationSchema(),
    IAMAccountEntity
  );

  constructor(readonly value: IAMAccountCredentialsDownloadCmdRaw) {
    JsonSchemaValidator.assert(
      IAMAccountCredentialsDownloadCmd.validation,
      value
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["account"],
      properties: {
        account: {
          instanceof: IAMAccountEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface IAMAccountCredentialsDownloadCmdRaw {
  account: IAMAccountEntity;
}
